import gqlRequest from 'graphql/generic';
import { createEntryForm } from '../types';

const queryCreateEntry = `
mutation HelpOrderLinkedEntry($id: ID!, $code: OrderLedgerCodes!, $description: String!, $entryDate: String!, $kind: OrderLedgerKinds!, $targets: [OrderLinkedEntryContent!]!, $posted: Boolean) {
  helpOrderLinkedEntry(_id: $id, code: $code, description: $description, entry_date: $entryDate, kind: $kind, targets: $targets, posted: $posted) {
			_id
	}
}
`;

type createLinkParams = createEntryForm & {
  id: string;
};

type createLinkReturn = {
 	createOrderLedgerLink: {
    _id: string
  };
};

export const createLedgerLink = (params: createLinkParams) =>
  gqlRequest<createLinkReturn, createLinkParams>(queryCreateEntry, params);

type editentryReturn = {
  updateOrderLedgerEntry: {
    _id: string
  };
};

const queryEditEntry = `
mutation UpdateOrderLedgerEntry($id: ID!, $accountingId: ID!, $data: OrderLedgerEntryUpdateContent!) {
  updateOrderLedgerEntry(_id: $id, accounting_id: $accountingId, data: $data) {
		_id
	}
}
`;

type editEntryParams = {
  id: string;
  accountingId: string;
  data: {
    amount_override: number;
    code: string;
    description: string;
    entry_date: string;
  };
};

export const mutationEditEntry = (params: editEntryParams) =>
  gqlRequest<editentryReturn, editEntryParams>(queryEditEntry, params);

type updatePostedReturn = {
  updateOrderLedgerPosted: {
    _id: string
  };
};

const queryUpdatePosted = `
mutation updateOrderLedgerPosted($id: ID!, $accountingId: ID!, $posted: Boolean!) {
  updateOrderLedgerPosted(_id: $id, accounting_id: $accountingId, posted: $posted) {
		_id
	}
}
`;

type updatePostedParams = {
  id: string;
  accountingId: string;
  posted: boolean;
};

export const mutationUpdatePosted = (params: updatePostedParams) =>
  gqlRequest<updatePostedReturn, updatePostedParams>(queryUpdatePosted, params);
